module.exports = __webpack_public_path__ + "img/27.d4182281.jpeg";